import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { IValues } from './AccountLookup';
import Input from '../../components/forms/Input';
import { useLoqateRetrieve } from '../../hooks/queryHooks';
import Loqate from '../../components/loqate/Loqate';

const TuAddress = ({
  values,
  setValues,
  addressType = 'current'
}: {
  values: IValues;
  setValues: Dispatch<SetStateAction<IValues>>;
  addressType: 'previous' | 'current';
}) => {
  const key = addressType == 'previous' ? 'previousAddress' : 'address';

  const [selectedId, setSelectedId] = useState<string | null | undefined>();
  const { data: finalAddress, isLoading: isFinalAddressLoading } = useLoqateRetrieve(selectedId ?? '');
  const isFinalAddressAvailable = Object.keys(finalAddress || {}).length > 0;
  const showAddressFields = selectedId === null || isFinalAddressAvailable || Object.keys(values[key] || {}).length > 0;

  const addressDetails = {
    buildingName: finalAddress?.buildingName,
    buildingNumber: finalAddress?.buildingNumber,
    dependentLocality: finalAddress?.dependentLocality,
    postcode: finalAddress?.postcode || '',
    postTown: finalAddress?.postTown || '',
    subBuildingName: finalAddress?.subBuildingName,
    thoroughfareName: finalAddress?.thoroughfareName
  };

  useEffect(() => {
    if (isFinalAddressAvailable) {
      setValues(prev => ({ ...prev, [key]: { ...prev[key], ...addressDetails } }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinalAddressAvailable]);
  return (
    <>
      {!showAddressFields && (
        <Loqate
          setSelectedId={setSelectedId}
          isFinalAddressLoading={isFinalAddressLoading}
          className="sm:col-span-2 mb-3 mt-3"
          onAddressNotListed={() => {
            setSelectedId(null);
            setValues(prev => ({
              ...prev,
              [key]: {
                postTown: '',
                postcode: ''
              }
            }));
          }}
        />
      )}
      <fieldset className={`${showAddressFields ? 'grid' : 'hidden'} grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 mt-4`}>
        <legend className="font-normal text-md mb-3">
          {addressType == 'previous' ? 'Previous' : null} Address details
        </legend>
        <Input
          label="Building name"
          required={!values[key]?.buildingNumber}
          key={`${!values[key]?.buildingNumber}-buildingNumber`}
          placeholder="E.g. The Old Bakery"
          pattern="^[^!&<>]*$"
          title="Invalid, characters '&,<,>' are not allowed"
          value={values[key]?.buildingName}
          onChange={e => setValues(prev => ({ ...prev, [key]: { ...prev[key], buildingName: e.target.value } }))}
        />
        <Input
          label="Sub building name (optional)"
          placeholder="E.g. Flat 3B"
          pattern="^[^!&<>]*$"
          title="Invalid, characters '&,<,>' are not allowed"
          value={values[key]?.subBuildingName}
          onChange={e => setValues(prev => ({ ...prev, [key]: { ...prev[key], subBuildingName: e.target.value } }))}
        />
        <Input
          label="Building number"
          required={!values[key]?.buildingName}
          key={`${!values[key]?.buildingName}-buildingName`}
          placeholder="E.g. 42"
          pattern="^[^!&<>]*$"
          title="Invalid, characters '&,<,>' are not allowed"
          value={values[key]?.buildingNumber}
          onChange={e => setValues(prev => ({ ...prev, [key]: { ...prev[key], buildingNumber: e.target.value } }))}
        />
        <Input
          label="Street"
          required={true}
          placeholder="E.g. High Street"
          value={values[key]?.thoroughfareName}
          onChange={e => setValues(prev => ({ ...prev, [key]: { ...prev[key], thoroughfareName: e.target.value } }))}
          pattern="^[^!&<>]*$"
          title="Invalid, characters '!,<,>,/,\,&' are not allowed"
        />
        <Input
          label="City / Town"
          required={true}
          placeholder="London"
          pattern="^[^!&\\\/<>]*$"
          title="Invalid, characters '!,<,>,/,\,&' are not allowed"
          value={values[key]?.postTown}
          onChange={e => setValues(prev => ({ ...prev, [key]: { ...prev[key], postTown: e.target.value } }))}
        />
        <Input
          label="County (optional)"
          placeholder="E.g. West Dulwich"
          value={values[key]?.dependentLocality}
          onChange={e => setValues(prev => ({ ...prev, [key]: { ...prev[key], dependentLocality: e.target.value } }))}
          pattern="^[^!&\\\/<>]*$"
          title="Invalid, characters '!,<,>,/,\,&' are not allowed"
        />
        <Input
          label="Post code"
          required={true}
          placeholder="E.g. SE21 8JY"
          value={values[key]?.postcode}
          onChange={e => setValues(prev => ({ ...prev, [key]: { ...prev[key], postcode: e.target.value } }))}
          pattern="^([Gg][Ii][Rr] 0[Aa]{2}|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) ?[0-9][A-Za-z]{2}))$"
          title="Enter a valid UK postcode (e.g., SE21 8JY)"
        />
      </fieldset>
    </>
  );
};

export default TuAddress;
